import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class MonitoringErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  public override handleError(error: Error): void {

    // this.traceService.registerError(TraceError.EXECUTION_ERROR, error);

    if (!environment.production) {
      super.handleError(error);
    }
  }
}

